<template>
  <OArticleCard
    v-bind="$attrs"
    class="categoryArticle h-full rounded-md flex sm:flex-row flex-col items-stretch bg-white mr-4 sm:mr-0 overflow-hidden"
  >
    <template #desktop>
      <div class="flex flex-col my-auto px-8 py-0">
        <OArticleLiveCount class="mb-2" />
        <OArticleTitle
          class="hover:text-link-primary text-primary-100 font-semibold tracking-tight text-24 leading-32 line-clamp-3"
          link
          overlay
        />
        <OArticleDescription class="text-primary-200 text-base leading-24 font-normal my-2 line-clamp-3" />
        <OArticleVariant name="category" class="flex items-center">
          <OArticleHashtag class="leading-22 mr-auto" />
          <OArticleWatchVideo type="slider" class="ml-auto" />
        </OArticleVariant>
        <OArticleVariant name="tag" class="flex">
          <OArticleHashtag class="leading-22 mr-auto z-2" />
          <OArticleCategory class="leading-22 relative ml-auto z-2" />
        </OArticleVariant>
      </div>
      <OArticleCover width="498" class="flex-shrink-0" :lazy="lazy" />
    </template>
    <template #mobile>
      <OArticleCover :lazy="lazy" />
      <div class="flex flex-col p-4">
        <OArticleTitle
          class="hover:text-link-primary text-primary-100 font-semibold tracking-tight text-lg leading-24 line-clamp-2"
          link
          overlay
        />
        <OArticleDescription class="text-primary-200 text-base leading-24 font-normal my-2 line-clamp-2" />
        <OArticleVariant name="category">
          <OArticleHashtag class="leading-22" />
        </OArticleVariant>
        <OArticleVariant name="tag" class="flex">
          <OArticleHashtag class="leading-22 mr-auto z-2" />
          <OArticleCategory class="leading-22 relative ml-auto z-2" />
        </OArticleVariant>
        <OArticleLiveCount class="mt-2" />
      </div>
    </template>
  </OArticleCard>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import OArticleHashtag from '@/modules/card/components/ArticleHashtag';
import OArticleCategory from '@/modules/card/components/ArticleCategory';
import OArticleLiveCount from '@/modules/card/components/ArticleLiveCount';
import OArticleCard from '~/modules/card/components/ArticleCard';
import OArticleCover from '~/modules/card/components/ArticleCover';
import OArticleTitle from '~/modules/card/components/ArticleTitle';
import OArticleVariant from '~/modules/card/components/ArticleVariant';
import OArticleDescription from '~/modules/card/components/ArticleDescription';
import OArticleWatchVideo from '~/modules/card/components/ArticleWatchVideo';

export default defineComponent({
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleVariant,
    OArticleDescription,
    OArticleHashtag,
    OArticleCategory,
    OArticleWatchVideo,
    OArticleLiveCount,
  },
  inheritAttrs: false,
  props: {
    lazy: {
      type: Boolean,
      default: true,
    },
  },
});
</script>
